import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import DecorLayer from '../effects/DecorLayer';

import { WalletBadge } from '../shop/WalletBadge';
import Logo from '../ui/Logo'; // [NEW]
import FeedbackWidget from '../common/FeedbackWidget';

const MainLayout: React.FC = () => {
    const location = useLocation();
    const isLanding = location.pathname === '/';

    return (
        <div className="min-h-screen w-screen bg-[var(--bg-primary)] overflow-hidden flex flex-col font-sans relative text-[var(--text-primary)] transition-colors duration-500">
            {/* GLOBAL DECOR LAYER (The World) */}
            <DecorLayer />

            {/* BRANDING HEADER (Hidden on Landing Page) */}
            <div className="absolute top-6 left-8 z-50 pointer-events-none select-none opacity-80 mix-blend-screen w-[calc(100%-4rem)] flex justify-between items-start">
                <Logo variant="combined" size="sm" animated={false} />

                {/* [NEW] WALLET BADGE - Top Right */}
                <div className="pointer-events-auto mt-2">
                    <WalletBadge />
                </div>
            </div>

            {/* Feedback Widget */}
            <FeedbackWidget />

            {/* PAGE CONTENT */}
            <div className="relative z-10 flex-1 flex flex-col h-full overflow-hidden">
                <React.Suspense fallback={<div className="flex items-center justify-center h-full text-gold-500 font-mono animate-pulse">Chargement du flux...</div>}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={location.pathname}
                            initial={{ opacity: 0, filter: 'blur(10px)' }}
                            animate={{ opacity: 1, filter: 'blur(0px)' }}
                            exit={{ opacity: 0, filter: 'blur(10px)' }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            className="flex-1 flex flex-col h-full overflow-y-auto"
                        >
                            <Outlet />
                        </motion.div>
                    </AnimatePresence>
                </React.Suspense>
            </div>
        </div>
    );
};

export default MainLayout;
